import { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { showEmailVerificationFlowModal } from '../../actions/modals'

// Auto-opens the centered verify-primary / add-backup modal (same pattern as
// the rest of the app's modals, e.g. Update Email) once per app session,
// as soon as the server says a prompt is due and no other modal is in the way.
function EmailVerificationBannerContainer(props) {
  const {
    prompts, currentModal, hasBackupEmail, showEmailVerificationFlowModal,
  } = props
  const shownVariantsRef = useRef(new Set())

  useEffect(() => {
    if (currentModal) return // don't interrupt whatever modal is already open

    // priority: a full primary re-verify beats everything (it needs a code).
    // When both affirms are due at once *and* there's actually a backup email
    // to show, combine them into one "are these still yours?" screen instead
    // of two sequential lightweight asks — affirmBackup without a real
    // backupEmail set would just render an empty section, so it's treated as
    // not due. A full add-backup ask still beats a stale-backup affirm.
    const affirmBackupDue = prompts.affirmBackup && hasBackupEmail
    let variant = null
    let initialStep = null
    if (prompts.verifyPrimary) {
      variant = 'verifyPrimary'
      initialStep = 'verifyPrimaryOffer'
    } else if (prompts.affirmPrimary && affirmBackupDue) {
      variant = 'affirmBoth'
      initialStep = 'affirmBothOffer'
    } else if (prompts.affirmPrimary) {
      variant = 'affirmPrimary'
      initialStep = 'affirmPrimaryOffer'
    } else if (prompts.addBackup) {
      variant = 'addBackup'
      initialStep = 'backupOffer'
    } else if (affirmBackupDue) {
      variant = 'affirmBackup'
      initialStep = 'affirmBackupOffer'
    }
    if (!variant || shownVariantsRef.current.has(variant)) return

    shownVariantsRef.current.add(variant)
    showEmailVerificationFlowModal(variant, initialStep)
  }, [prompts.verifyPrimary, prompts.affirmPrimary, prompts.addBackup, prompts.affirmBackup,
    hasBackupEmail, currentModal])

  return null
}

export default connect(
  (state) => ({
    prompts: state.emailVerification.prompts,
    hasBackupEmail: !!state.user.backupEmail,
    currentModal: state.modals.currentModal,
  }),
  { showEmailVerificationFlowModal },
)(EmailVerificationBannerContainer)
